import {
    styled,
} from "@mui/material"
import { Form as FormikForm } from "formik"

import { CTAButton } from "../CTAButton"

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const ButtonsContainer = styled("div")(() => ({
    marginTop: "auto",
    display: "flex",
    justifyContent: "right",
}))

export const CancelButton = styled(CTAButton)(() => ({
    width: "fit-content",
}))

export const Form = styled(FormikForm)(() => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
}))